import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
  const gbBuilderMedias = document.querySelectorAll('.gb-builder-media');

  if (gbBuilderMedias.length === 0) return;

  function playActiveGbBuilderMedia(gbBuilderMedia, activeIndex) {
    const activeSlide = gbBuilderMedia.querySelectorAll('.gb-builder-media__slide')[activeIndex];

    if (!activeSlide) return;

    activeSlide.querySelectorAll('video').forEach((video) => {
      video.muted = true;
      video.play().catch(() => {});
    });
  }

  function pauseInactiveGbBuilderMedia(gbBuilderMedia, activeIndex) {
    const slides = gbBuilderMedia.querySelectorAll('.gb-builder-media__slide');

    slides.forEach((slide, index) => {
      if (index === activeIndex) return;

      slide.querySelectorAll('video').forEach((video) => {
        if (!video.paused) {
          video.pause();
        }
      });

      slide.querySelectorAll('iframe').forEach((iframe) => {
        const iframeSrc = iframe.getAttribute('src') || '';

        if (!iframeSrc.includes('youtube.com') && !iframeSrc.includes('youtu.be')) {
          return;
        }

        iframe.contentWindow?.postMessage(
          JSON.stringify({
            event: 'command',
            func: 'pauseVideo',
            args: [],
          }),
          '*'
        );
      });
    });
  }

  function setupGbBuilderMedia(gbBuilderMedia) {
    const gbBuilderMediaSwiper = gbBuilderMedia.querySelector('.gb-builder-media__swiper');

    if (!gbBuilderMediaSwiper || gbBuilderMediaSwiper.swiper) return;

    new Swiper(gbBuilderMediaSwiper, {
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      updateOnWindowResize: true,
      allowTouchMove: true,
      loop: false,
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 0,
      pagination: {
        el: gbBuilderMedia.querySelector('.gb-builder-media__pagination'),
        clickable: true,
      },
      on: {
        init(swiper) {
          pauseInactiveGbBuilderMedia(gbBuilderMedia, swiper.activeIndex);
          playActiveGbBuilderMedia(gbBuilderMedia, swiper.activeIndex);
        },
        slideChangeTransitionEnd(swiper) {
          pauseInactiveGbBuilderMedia(gbBuilderMedia, swiper.activeIndex);
          playActiveGbBuilderMedia(gbBuilderMedia, swiper.activeIndex);
        },
      },
    });
  }

  gbBuilderMedias.forEach(setupGbBuilderMedia);
});
